"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "acqualagna": {
    "e72b4030": [{
      "hkey": "1d8b369a",
      "slug": "bellaria-pole-petriccio",
      "name": "Bellaria-Pole-Petriccio",
      "primary": true,
      "skipSearch": false
    }],
    "bellaria": [{
      "hkey": "1d8b369a",
      "slug": "bellaria-pole-petriccio",
      "name": "Bellaria-Pole-Petriccio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ae4ce5a2": [{
      "hkey": "ce769a26",
      "slug": "acqualagna",
      "name": "Acqualagna",
      "primary": true,
      "skipSearch": false
    }],
    "case-nuove": [{
      "hkey": "ce769a26",
      "slug": "acqualagna",
      "name": "Acqualagna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ba769616": [{
      "hkey": "ce769a26",
      "slug": "acqualagna",
      "name": "Acqualagna",
      "primary": true,
      "skipSearch": false
    }],
    "farneta": [{
      "hkey": "ce769a26",
      "slug": "acqualagna",
      "name": "Acqualagna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e21e9311": [{
      "hkey": "1d8b369a",
      "slug": "bellaria-pole-petriccio",
      "name": "Bellaria-Pole-Petriccio",
      "primary": true,
      "skipSearch": false
    }],
    "petriccio": [{
      "hkey": "1d8b369a",
      "slug": "bellaria-pole-petriccio",
      "name": "Bellaria-Pole-Petriccio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "acqualagna"
    }],
    "b44ec696": [{
      "hkey": "1d8b369a",
      "slug": "bellaria-pole-petriccio",
      "name": "Bellaria-Pole-Petriccio",
      "primary": true,
      "skipSearch": false
    }],
    "pole": [{
      "hkey": "1d8b369a",
      "slug": "bellaria-pole-petriccio",
      "name": "Bellaria-Pole-Petriccio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "acqualagna"
    }]
  }
};
exports["default"] = _default;